export default "__VITE_ASSET__DhrWU3tU__"